// extracted by mini-css-extract-plugin
module.exports = {"card":"EventCard_card__SR95n","image":"EventCard_image__QCSyN","timeAgo":"EventCard_timeAgo__BIt_E"};